export default __webpack_public_path__ + "static/media/receipt.7f5dc2cf.svg";